export { default as ListadoEntradas } from "./Listado";
